import React from 'react'
import Navbar from '../common/Navbar';
import '../styles/termsPrivacy.css'
import ScrollToTop from './ScrolltoTop';
import '../App.css'

function TermsAndConditions() {
  return (
    <div>
      <ScrollToTop/>

      <Navbar /> <br />
      <div className="tCdata">
        <h1>TERMS AND CONDITIONS</h1> <br />
        <p>Welcome to our website. By continuing to explore and utilize this website, you are consenting to adhere to and be governed by the subsequent terms and conditions of use. These terms, along with our privacy policy, dictate the framework of our association with you concerning this website.
          <br />
          The expression 'Swami Event Managment' or 'we' or 'us' denotes the proprietor of this website, with its registered office situated in Khariar, Odisha. In this context, the term 'you' pertains to the user or observer of our website.</p><br /> <br />

        <p>
          <b> The utilization of this website implies your acceptance of the ensuing terms of use:</b> <br /><br />

          The information and materials provided on this website are for general information purposes only and are subject to alteration without prior notice.<br /><br />

          Neither we nor any third parties guarantee the accuracy, timeliness, performance, completeness, or suitability of the information and materials available on this website for any specific purpose. You acknowledge that such information and materials may contain inaccuracies or errors, and we disclaim liability for any such inaccuracies or errors to the maximum extent permitted by law.<br /><br />

          Your use of any information or materials on this website is entirely at your own risk. It is your responsibility to ensure that any products, services, or information obtained through this website meet your specific requirements.<br /><br />

          The material contained on this website is either owned by us or licensed to us. This includes, but is not limited to, the design, layout, appearance, and graphics. Reproduction of this material is prohibited except in accordance with the copyright notice, which is an integral part of these terms and conditions.<br /><br />

          All trademarks featured on this website, which are not owned by or licensed to the operator, are acknowledged on the website.<br /><br />

          Unauthorized usage of this website may result in a claim for damages and/or be considered a criminal offense.<br /><br />

          Occasionally, this website may include links to other websites for additional information. These links are provided for your convenience and do not imply endorsement by us. We are not responsible for the content of linked websites.<br /><br />

          You are prohibited from creating a link to this website from another website or document without obtaining prior written consent.<br /><br />

          Your use of this website and any disputes arising from such use are governed by the laws of India or any other applicable regulatory authority.<br /><br />

          "We, as a merchant, shall not be held liable for any loss or damage resulting directly or indirectly from the rejection of authorization for any Transaction, due to the Cardholder surpassing the preset limit agreed upon by us and our acquiring bank at various times."
        </p><br /><br />


        <p>
          <b> Privacy Policy</b><br /><br />

          We are dedicated to safeguarding your privacy. If we request certain information by which you can be identified while using this website, rest assured that it will only be utilized in accordance with this privacy statement.<br /><br />

          Swami Event Managment may revise this policy periodically by updating this page. We recommend checking this page occasionally to ensure your satisfaction with any modifications.<br /><br />

          <b>What We Collect</b>

          <b>We may gather the following information: </b><br /><br />

          - Name and occupation<br />
          - Contact details including email address<br />
          - Demographic details such as postal code<br />
          - Preferences and interests<br />
          - Other information pertinent to customer surveys and/or offers<br /><br />

          <b>What We Do with the Information We Gather </b><br /><br />

          We gather this information to comprehend your requirements better and offer you an enhanced service, particularly for the following reasons:<br /><br />

          - Maintenance of internal records<br />
          - Enhancement of our products and services<br />
          - Periodic dispatch of promotional emails regarding new products, exclusive offers, or other information we believe may be of interest to you, using the email address you have provided<br />
          - Occasional contact for market research purposes via email, telephone, fax, or mail<br />
          - Customization of the website based on your interests<br />
        </p>

        <b> Security</b> <br />

        We are committed to ensuring that your information is secure. In order to prevent unauthorised access or disclosure we have put in place suitable physical, electronic and managerial procedures to safeguard and secure the information we collect online.<br /><br />




      <b> How we use cookies</b> <br />

        A cookie is a small file which asks permission to be placed on your computer's hard drive. Once you agree, the file is added and the cookie helps analyze web traffic or lets you know when you visit a particular site. Cookies allow web applications to respond to you as an individual. The web application can tailor its operations to your needs, likes and dislikes by gathering and remembering information about your preferences.<br /><br />

        We use traffic log cookies to identify which pages are being used. This helps us analyse data about webpage traffic and improve our website in order to tailor it to customer needs. We only use this information for statistical analysis purposes and then the data is removed from the system.<br /><br />

        Overall, cookies help us provide you with a better website, by enabling us to monitor which pages you find useful and which you do not. A cookie in no way gives us access to your computer or any information about you, other than the data you choose to share with us.<br /><br />

        You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. This may prevent you from taking full advantage of the website.<br /><br />


      <b> Controlling your personal information </b> <br />


        You may choose to restrict the collection or use of your personal information in the following ways:<br />

        whenever you are asked to fill in a form on the website, look for the box that you can click to indicate that you do not want the information to be used by anybody for direct marketing purposes<br />

        if you have previously agreed to us using your personal information for direct marketing purposes, you may change your mind at any time by writing to or emailing us at support@swamieventmanagment.com<br />

        We will not sell, distribute or lease your personal information to third parties unless we have your permission or are required by law to do so. We may use your personal information to send you promotional information about third parties which we think you may find interesting if you tell us that you wish this to happen.<br /><br />



       <b>Website disclaimer:</b> <br />



        The information contained in this website is for general information purposes only and while we endeavor to keep the information up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability or availability with respect to the website or the information, products, services, or related graphics contained on the website for any purpose. Any reliance you place on such information is therefore strictly at your own risk.<br /><br />

        In no event will we be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arising out of, or in connection with, the use of this website.<br /><br />

        Through this website you are able to link to other websites which are not under the control of this business. We have no control over the nature, content and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.<br /><br />

        Every effort is made to keep the website up and running smoothly. However, we takes no responsibility for, and will not be liable for, the website being temporarily unavailable due to technical issues beyond our control.<br /><br />

        Cancellation & Refund Policy: Cancellation and Refund policy depends on the hotels and resorts where the reservation has been made, and it varies from hotel to a hotel and factors such as the seasonality, duration between the date of cancellation and the check in date, etc.

      </div>
    </div>
  )
}

export default TermsAndConditions;
